import { render, staticRenderFns } from "./AddressManagement.vue?vue&type=template&id=42c2eb60&scoped=true&"
import script from "./AddressManagement.vue?vue&type=script&lang=js&"
export * from "./AddressManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c2eb60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/coachingclub/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42c2eb60')) {
      api.createRecord('42c2eb60', component.options)
    } else {
      api.reload('42c2eb60', component.options)
    }
    module.hot.accept("./AddressManagement.vue?vue&type=template&id=42c2eb60&scoped=true&", function () {
      api.rerender('42c2eb60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Account/Children/Address/AddressManagement.vue"
export default component.exports